<template>
    <div class="item_title">
        <h1>{{title}}</h1>
        <!-- <div class="item_title_hr" style="width:100%"> -->
            <!-- <div v-if="chOrEn!='0'" style="text-align:left;color:#C0CCDA;font-size:20px;font-weight: bold;">Union Members</div>
            <div v-else style="text-align:left;color:#C0CCDA;font-size:20px;font-weight: bold;">成员单位</div> -->
            <!-- <div class="title_hr_line"></div> -->
            <!-- <div class="title_hr_dots">
                <div class="dot_little"></div>
                <div class="dot_big"></div>
                <div class="dot_little"></div>
            </div> -->
            <!-- <div class="title_hr_line"></div> -->
        <!-- </div> -->
        <h5>{{des}}</h5>
    </div>
</template>

<script>
    export default {
        name:'itemtitle',
        data() {
            return {
                chOrEn:sessionStorage.getItem('chOrEn'),
            }
        },
        props:{
            title:{
                type:String,
                value:''
            },
            des:{
                type:String,
                value:''
            }
        }
    }
</script>

<style lang="less" scoped>
.item_title{
    text-align: center;
    h1{
        // line-height: 94px;
        font-weight: bold;
        padding-top:40px;
        font-size: 40px;
        color: #000000;
    }
    .item_title_hr{
        // width: 164px;
        height: 10px;
        margin:0 auto;
        // display: flex;
        // justify-content: space-around;
        // align-items: center;
        .title_hr_line{
            width: 60px;
            height: 1px;
            background:#0a2f8e;
        }
        .title_hr_dots{
            display: flex;
            justify-content: space-around;
            align-items: center;
            .dot_little{
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: #0a2f8e;
                margin:0 3px;
            }
            .dot_big{
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: #0a2f8e;
                 margin:0 3px;
            }
        }
    }
    h5{
        font-size: 18px;
        color: #464b4f;
        line-height: 64px;
    }
}
</style>